











































































import { Component,Vue } from 'vue-property-decorator'
import { State,  Getter, Action, namespace } from 'vuex-class'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
const site = namespace('site')
@Component({
    components:{
        Treeselect
    }
})
export default class SiteList extends Vue{
    dockingPopup:boolean = false //数据对接的弹窗
    dockingId:string = '' //数据对接的网点id
    docking:any = {
        excom:'', //选择对接的快递公司
        action: ''
    }
    @site.State('loading') loading:any 
    @site.State('sitePager') sitePager:any //表格的页码
    @site.State('list') list:any //网点列表
    @Getter('siteType') siteType:any //网点类型
    @Getter('siteOrg') siteOrg:any //组织架构
    @Getter('excomList') excomList:any //快递公司列表
    
    search:any = {
        com_area: '', //公司区域
        name: '', //网点名
        phone: '', // 电话
        type: '', //网点类型
        site_org: null, //组织架构
        page: 1
    }
    get tablecolumn(){
        return [
            {
                prop: 'name',
                type: 'text',
                label: '网点名称',

            },
            {
                prop: 'com_area',
                name:'com_area',
                type: 'slot',
                label: '公司区域',
            },
            {
                prop: 'phone',
                type: 'text',
                label: '电话',

            },
            {
                prop: 'address',
                type: 'text',
                label: '网点地址',

            },
            {
                prop: 'sms_address',
                type: 'text',
                label: '短信地址',

            },
            {
                prop: 'price',
                nextProp: 'sms',
                type: 'nextProp',
                label: '短信费用',

            },
            {
                prop: 'price',
                nextProp: 'weixin',
                type: 'nextProp',
                label: '微信费用',
            },
            {
                prop: 'type',
                name:'type',
                type: 'slot',
                label: '类型',

            },
            {
                prop: 'status',
                name:'status',
                type: 'slot',
                label: '状态',

            },
            {
                prop: 'totc',
                name:'totc',
                type: 'slot',
                label: '营业时间',
                width: '110px'
            },
            {
                prop: 'name',
                name:'operation',
                type: 'slot',
                label: '操作',
                width: '240px'
            }
        ]
    }
    
    @site.Mutation('changeList') changeList:any //出库改变本地状态
    @site.Action('getSiteList') getSiteList:any
    @site.Action('modifyStatus') modifyStatus:any
    @site.Action('createDocking') createDocking:any
    
    
    async created(){
        await this.getList()
        console.log(this.siteOrg);
        
    }
    async getList(){
        await this.getSiteList(this.search)
    }
    // 将返回的数字转换成类型对应的汉字
    switchType(val:string){
        let name = ''
        this.siteType.forEach((item:any) => {
            if(val == item.code){
                name = item.name
            }
        })
        return name
    }
    // 配置树形图的参数
    normalizer(node:any) {
        let data = {}
        this.siteOrg.forEach((item:any) => {
            data = {
                id: node["_id"],
                label: node["name"],
                children: node.children,
            }
            
        });
        return data
        
    }
    // 编辑
    edit(id:string){
        this.$router.push(`/site/edit?id=${id}`)
    }
    // 改变状态
    async switchStatus(val:string,id:string,index:number){
        let status = '0';
        if(val == '0'){
            status = '1'
        }else{
            status = '0'
        }
        const res = await this.modifyStatus({
            id: id,
            data: {
                status: status
            }
        })
        if(res){
            this.changeList(index)
            this.$message({ message: '修改成功', type: 'success' });
        }
    }
    // 翻页
    pagechange(e:any){
        this.search.page = e[0].val
        this.getList()
    }
    // 打开数据对接弹窗
    openDockingPopup(id:string){
        this.dockingId = id
        this.dockingPopup = true
    }
    // 数据对接
    async createInterface(){
        console.log(this.docking.action);
        if(this.docking.action == '' || this.docking.excom == ''){
            this.$message.error('请将参数填写完整');
            return
        }
        this.createDocking({...this.docking,id:this.dockingId})
    }
}
